import CloseIcon from '@mui/icons-material/Close';
import { Chip } from '@mui/material';
import { AlertCard, IconTooltip } from 'common/ui';
import { CandidateAnalysisErrorCode } from 'generated-graphql/types';

const messages: Record<CandidateAnalysisErrorCode, string> = {
  [CandidateAnalysisErrorCode.DocumentTooLarge]:
    'The CV file is too large. Upload a smaller file to get a score.',
  // Placeholder: the backend added this code and the exhaustive Record forced an
  // entry. Says what the fallback already said, so nothing a recruiter sees
  // changes until someone who owns the analysis flow writes the real copy.
  [CandidateAnalysisErrorCode.AnalysisInputUnavailable]:
    'Upload the CV again to get a score.',
  [CandidateAnalysisErrorCode.AnalysisFailed]:
    'Upload the CV again to get a score.'
};

export const analysisErrorMessage = (
  code: CandidateAnalysisErrorCode
): string => messages[code] ?? 'Upload the CV again to get a score.';

export const AnalysisErrorNotice: React.FC<{
  code: CandidateAnalysisErrorCode;
}> = ({ code }) => (
  <AlertCard type="error" title="We could not analyse this CV">
    {analysisErrorMessage(code)}
  </AlertCard>
);

export const AnalysisErrorChip: React.FC<{
  code: CandidateAnalysisErrorCode;
}> = ({ code }) => (
  <IconTooltip title={analysisErrorMessage(code)}>
    {/* Same shape as the error statuses in CandidateStatusChip. */}
    <Chip label="Failed" color="error" icon={<CloseIcon fontSize="small" />} />
  </IconTooltip>
);
